import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  Modal: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      padding: '0px',
      maxWidth: '500px',
      width: '100%',
    },
  },
  Box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px',
  },
  BoxHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  BoxTitleModal: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  TitleModal: {
    display: 'flex',
    alignItems: 'center',
  },
  Icon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  BoxContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  BoxFooter: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  },
}));
